import { AuthActionTypes } from './action.type';

export const AuthMutations = {
    [AuthActionTypes.SetUserInfo](state, userInfo) {
        state.userInfo = userInfo;
    },

    [AuthActionTypes.SetCustomerInfo](state, customerInfo) {
        state.customerInfo = customerInfo;
    },

    [AuthActionTypes.LogOut](state) {
        state.userInfo = {
            email: '',
            userId: 0,
            userName: '',
        };
    },
};

